import React, {createContext, useCallback, useContext, useState} from 'react';

const KEY = 'bioretis-consent-v1';
const ConsentContext = createContext(null);

function readConsent() {
    if (typeof window === 'undefined') return null;
    try {
        const stored = JSON.parse(window.localStorage.getItem(KEY));
        return stored && stored.version === 1 && typeof stored.googleMaps === 'boolean'
            ? stored.googleMaps : null;
    } catch (_) { return null; }
}

export function ConsentProvider({children}) {
    const [googleMaps, setGoogleMaps] = useState(readConsent);
    const [settingsOpen, setSettingsOpen] = useState(false);
    const chooseGoogleMaps = useCallback((allowed) => {
        const value = Boolean(allowed);
        try {
            window.localStorage.setItem(KEY, JSON.stringify({version: 1, googleMaps: value}));
        } catch (_) { /* Continue with in-memory preference if storage is unavailable. */ }
        setGoogleMaps(value);
        setSettingsOpen(false);
    }, []);
    return (
        <ConsentContext.Provider value={{googleMaps, chooseGoogleMaps, settingsOpen, setSettingsOpen}}>
            {children}
        </ConsentContext.Provider>
    );
}

export function useConsent() {
    const context = useContext(ConsentContext);
    if (!context) throw new Error('useConsent must be used within ConsentProvider');
    return context;
}
